import React from 'react'
import './MobileControls.css'

export default function MobileControls({ onLeft, onRight, onUp, onDown, onRotate, onPause, gameType }) {
  const handleTouchStart = (e, callback) => {
    e.preventDefault()
    e.stopPropagation()
    if (callback) callback()
  }

  const handleTouchHold = (e, callback) => {
    e.preventDefault()
    const intervalId = setInterval(callback, 50)
    
    const stopHold = () => {
      clearInterval(intervalId)
      e.target.removeEventListener('touchend', stopHold)
      e.target.removeEventListener('touchcancel', stopHold)
    }
    
    e.target.addEventListener('touchend', stopHold)
    e.target.addEventListener('touchcancel', stopHold)
  }

  if (gameType === 'tetris') {
    return (
      <div className="mobile-controls">
        <div className="controls-row">
          <button
            className="control-btn"
            onTouchStart={(e) => handleTouchStart(e, onRotate)}
          >
            ↻
          </button>
        </div>
        <div className="controls-row">
          <button
            className="control-btn"
            onTouchStart={(e) => handleTouchHold(e, onLeft)}
          >
            ←
          </button>
          <button
            className="control-btn"
            onTouchStart={(e) => handleTouchHold(e, onDown)}
          >
            ↓
          </button>
          <button
            className="control-btn"
            onTouchStart={(e) => handleTouchHold(e, onRight)}
          >
            →
          </button>
        </div>
        <div className="controls-row">
          <button
            className="control-btn pause-btn"
            onTouchStart={(e) => handleTouchStart(e, onPause)}
          >
            ⏸
          </button>
        </div>
      </div>
    )
  }

  if (gameType === 'snake') {
    return (
      <div className="mobile-controls">
        <div className="controls-row">
          <button
            className="control-btn"
            onTouchStart={(e) => handleTouchStart(e, onUp)}
          >
            ↑
          </button>
        </div>
        <div className="controls-row">
          <button
            className="control-btn"
            onTouchStart={(e) => handleTouchStart(e, onLeft)}
          >
            ←
          </button>
          <button
            className="control-btn pause-btn"
            onTouchStart={(e) => handleTouchStart(e, onPause)}
          >
            ⏸
          </button>
          <button
            className="control-btn"
            onTouchStart={(e) => handleTouchStart(e, onRight)}
          >
            →
          </button>
        </div>
        <div className="controls-row">
          <button
            className="control-btn"
            onTouchStart={(e) => handleTouchStart(e, onDown)}
          >
            ↓
          </button>
        </div>
      </div>
    )
  }

  if (gameType === 'breakout') {
    return (
      <div className="mobile-controls breakout-controls">
        <div className="controls-row">
          <button
            className="control-btn wide-btn"
            onTouchStart={(e) => handleTouchHold(e, onLeft)}
            onTouchEnd={(e) => e.preventDefault()}
          >
            ← MOVER
          </button>
          <button
            className="control-btn pause-btn"
            onTouchStart={(e) => handleTouchStart(e, onPause)}
          >
            ⏸
          </button>
          <button
            className="control-btn wide-btn"
            onTouchStart={(e) => handleTouchHold(e, onRight)}
            onTouchEnd={(e) => e.preventDefault()}
          >
            MOVER →
          </button>
        </div>
      </div>
    )
  }

  return null
}
